import { useEffect, useState } from "react";

const PAGE_TOP_THRESHOLD = 50;

const isAtTopOfPage = () => {
  if (typeof window === "undefined") {
    return true;
  }

  return window.scrollY < PAGE_TOP_THRESHOLD;
};

export const useIsAtTopOfPage = () => {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    setIsAtTop(isAtTopOfPage());
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsAtTop(isAtTopOfPage());
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return isAtTop;
};
